import { FC } from 'react';
import { useHistory, useLocation } from 'react-router';
import { v4 as uuidv4 } from 'uuid';

import { useLocalStorage } from 'utils/hooks/useLocalStorage';

import { getAuthCode, getAuthUrl } from '../utils';
import { LoginContext } from './LoginContext';

export const LoginContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const [authState, setAuthState] = useLocalStorage('movable-ink-auth-state', uuidv4());

  const location = useLocation();
  const history = useHistory();
  const authUrl = getAuthUrl(authState);
  const { code, state } = getAuthCode();

  const authReset = () => {
    const queryParams = new URLSearchParams(location.search);
    if (queryParams.has('code') || queryParams.has('state')) {
      queryParams.delete('code');
      queryParams.delete('state');
      history.replace({ search: queryParams.toString() });
    }
    setAuthState(uuidv4()); // Cross-site request forgery (CSRF) protection
  };

  const value = {
    authCode: code,
    authStateIsValid: state === authState,
    authReset,
    authUrl,
  };

  return <LoginContext.Provider value={value}>{children}</LoginContext.Provider>;
};
